














import Vue from 'vue';
import Component from 'vue-class-component';
import { InjectReactive } from 'vue-property-decorator';

// Store types
import { ToolSystem, ToolAccessory, SpacesAction } from '@/store/store.types';

// Component for rendering the accessory of a system
import SystemAccessory from './SystemAccessory.vue';

/**
 *  Component that is responsible for rendering the available accessories of a system.
 */
@Component({
    components: {
        SystemAccessory,
    },
})
export default class SystemAccessories extends Vue {

    @InjectReactive('toolSystem')
    private toolSystem!: ToolSystem;

    /**
     *
     *  Used to toggle the selected state of the forwarded
     *  accessory and dispatching an action that updates
     *  the space data respectively.
     *
     *  @param accessory The (tool) accessory to update the selected state of
     *  @param selected Forced selected state, defaults to reverting the current state if not provided
     *
     */
    private toggleAccessory(accessory: ToolAccessory, selected?: boolean): void {

        accessory.selected = typeof selected === 'boolean' ? selected : !accessory.selected;

        this.$store.dispatch(SpacesAction.TOGGLE_ACCESSORY, accessory);

    }

}
